import { useState, useEffect } from "react";

import Logo from "./Logos/mainlogo.jpeg"

const IMGS = {
  hero:      "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?w=1920&q=95",
  about1:    "https://images.unsplash.com/photo-1631679706909-1844bbd07221?w=900&q=90",
  about2:    "https://images.unsplash.com/photo-1616137466211-f939a420be84?w=700&q=90",
  living1:   "https://images.unsplash.com/photo-1567767292278-a4f21aa2d36e?w=800&q=90",
  living2:   "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=800&q=90",
  bedroom:   "https://images.unsplash.com/photo-1616594039964-ae9021a400a0?w=800&q=90",
  kitchen:   "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800&q=90",
  bath:      "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=800&q=90",
  office:    "https://images.unsplash.com/photo-1497366216548-37526070297c?w=800&q=90",
  outdoor:   "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?w=800&q=90",
  fullwidth: "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?w=1920&q=90",
  staircase: "https://images.unsplash.com/photo-1600573472556-e636c2acda88?w=800&q=90",
  penthouse: "https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?w=800&q=90",
};

const PORTFOLIO = [
  { id:1, img:IMGS.living1,   title:"The Blanc Residence",  loc:"Banjara Hills",   tag:"Living Room",  year:"2024" },
  { id:2, img:IMGS.bedroom,   title:"Casa Serena",           loc:"Jubilee Hills",   tag:"Bedroom",      year:"2024" },
  { id:3, img:IMGS.kitchen,   title:"The Marble Kitchen",    loc:"Gachibowli",      tag:"Kitchen",      year:"2023" },
  { id:4, img:IMGS.bath,      title:"Onyx Spa Suite",        loc:"Madhapur",        tag:"Commercial",   year:"2023" },
  { id:5, img:IMGS.office,    title:"Obsidian HQ",           loc:"Hitec City",      tag:"Commercial",   year:"2024" },
  { id:6, img:IMGS.outdoor,   title:"The Terrace Villa",     loc:"Shamirpet",       tag:"Living Room",  year:"2024" },
  { id:7, img:IMGS.staircase, title:"Helix Residence",       loc:"Kondapur",        tag:"Living Room",  year:"2023" },
  { id:8, img:IMGS.penthouse, title:"Sky Penthouse",         loc:"Nanakramguda",    tag:"Bedroom",      year:"2024" },
];

const SERVICES_MAIN = [
  { n:"01", sub:"Home Spaces",  title:"Residential Design",   img:IMGS.living2, desc:"Complete residential transformations — from compact urban apartments to sprawling luxury villas, with modular kitchens and home renovation expertise." },
  { n:"02", sub:"Work Spaces",  title:"Commercial Design",    img:IMGS.office,  desc:"Brand-aligned commercial environments — corporate offices, retail stores, clinics, showrooms, salons and spas that captivate clients and inspire teams." },
  { n:"03", sub:"Host Spaces",  title:"Hospitality Design",   img:IMGS.bath,    desc:"Restaurant, cafe, hotel and resort interiors that create unforgettable guest experiences through atmosphere, material and spatial storytelling." },
];

const SERVICES_LIST = [
  { head:"Residential",         items:["Residential Interior Design","Villa & Independent House Interiors","Modular Kitchen Design","Home Renovation & Remodeling"] },
  { head:"Commercial",          items:["Corporate Office Interiors","Retail Store Design","Showroom Interiors","Salon & Spa Interiors","Clinic & Healthcare Interiors","Restaurant & Cafe Interiors","Hotel & Resort Interiors"] },
  { head:"Specialized Services",items:["Space Planning & Layout","3D Visualization & Rendering","Custom Furniture Design"] },
];


const TEAM = [
  {
    name: "Rajesh",
    role: "Principal Designer & Founder",
    exp: "9 years",
    initials: "R",
    tagline: "Architecture of feeling, not just form.",
    philosophy: "I believe every space carries an emotional frequency. My work is about tuning that frequency to the people who live and breathe within it — through material, restraint, and the careful choreography of light.",
    expertise: ["Luxury Residential", "Villa Interiors", "Spatial Storytelling", "Material Curation", "Lighting Design", "3D Visualization"],
    accolades: ["80+ Projects", "Pan-India Practice", "9+ Years"],
  },
];

const TESTIMONIALS = [
  { quote:"Working with this team was the most transformative experience. Our home now feels like a five-star sanctuary.",                      name:"Rahul & Pooja Singhania", role:"Homeowners · Banjara Hills",        initial:"R" },
  { quote:"Every detail was considered. The office redesign elevated our brand perception overnight — clients notice immediately.",             name:"Vikram Malhotra",         role:"CEO · Tech Startup, Gachibowli",    initial:"V" },
  { quote:"They transformed a raw 3BHK into a masterpiece. The spatial planning alone is worth every rupee.",                                  name:"Ananya Krishnan",         role:"Interior Enthusiast · Hyderabad",   initial:"A" },
];

const NAV_ITEMS = ["Home","About","Services","Portfolio","Team","Contact"];
const FILTERS   = ["All","Living Room","Bedroom","Kitchen","Commercial"];

const C = {
  bg:"#080808", bg2:"#0f0f0f", bg3:"#131313",
  gold:"#c8a96e", goldL:"#e8d4a8",
  white:"#f5f0eb", muted:"#6b6560",
  border:"rgba(200,169,110,0.18)", card:"#111111",
};

/* ── GLOBAL CSS ── */
const GlobalStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;0,700;0,900;1,400;1,700&family=Outfit:wght@200;300;400;500;600&display=swap');
    *{margin:0;padding:0;box-sizing:border-box}
    html{scroll-behavior:smooth}
    body{background:#080808;color:#f5f0eb;font-family:'Outfit',sans-serif;overflow-x:hidden;cursor:none}
    ::-webkit-scrollbar{width:3px}
    ::-webkit-scrollbar-track{background:#080808}
    ::-webkit-scrollbar-thumb{background:#c8a96e}

    @keyframes fadeUp{from{opacity:0;transform:translateY(40px)}to{opacity:1;transform:translateY(0)}}
    @keyframes kenBurns{from{transform:scale(1.08)}to{transform:scale(1)}}
    @keyframes marqueeAnim{from{transform:translateX(0)}to{transform:translateX(-50%)}}
    @keyframes floatAnim{0%,100%{transform:translateY(0)}50%{transform:translateY(-12px)}}
    @keyframes pulseAnim{0%,100%{opacity:1}50%{opacity:0.4}}

    .reveal{opacity:0;transform:translateY(48px);transition:all 0.9s cubic-bezier(0.22,1,0.36,1)}
    .reveal.vis{opacity:1;transform:translateY(0)}
    .reveal-l{opacity:0;transform:translateX(-50px);transition:all 0.9s cubic-bezier(0.22,1,0.36,1)}
    .reveal-l.vis{opacity:1;transform:translateX(0)}
    .reveal-r{opacity:0;transform:translateX(50px);transition:all 0.9s cubic-bezier(0.22,1,0.36,1)}
    .reveal-r.vis{opacity:1;transform:translateX(0)}

    .p-item:hover .p-img{transform:scale(1.1)}
    .p-item:hover .p-ov{opacity:1!important}
    .p-item:hover .p-arrow{transform:translateX(0)!important;opacity:1!important}
    .svc-card:hover{border-color:#c8a96e!important;transform:translateY(-4px)}
    .svc-card:hover .svc-img{transform:scale(1.06)}
    .team-card:hover .t-ov{opacity:1!important}
    .team-card:hover{border-color:#c8a96e!important}
    .nav-link:hover{color:#c8a96e!important}
    .fl:hover{color:#c8a96e!important}
    .filter-btn:not(.active):hover{border-color:#c8a96e!important;color:#c8a96e!important}
    .btn-gold:hover{background:transparent!important;color:#c8a96e!important}
    .btn-ol:hover{background:#c8a96e!important;color:#080808!important}
    .soc-btn:hover{border-color:#c8a96e!important;color:#c8a96e!important}
    .fsoc:hover{background:#c8a96e!important;color:#080808!important;border-color:#c8a96e!important}
    .sub-item:hover{color:#e8d4a8!important}

    @media(max-width:1024px){
      .svc-grid{grid-template-columns:repeat(2,1fr)!important}
      .team-grid{grid-template-columns:repeat(2,1fr)!important}
      .footer-grid{grid-template-columns:1fr 1fr!important}
      .svc-sub{grid-template-columns:1fr 1fr!important}
      .port-grid{columns:3 180px!important}
    }
    @media(max-width:768px){
      .nav-d{display:none!important}
      .ham{display:flex!important}
      .about-inner{flex-direction:column!important}
      .about-imgs{flex:none!important;width:100%!important}
      .ci{flex-direction:column!important}
      .ci-info{flex:none!important;width:100%!important}
      .stats-grid{grid-template-columns:repeat(2,1fr)!important}
      .tgrid{grid-template-columns:1fr!important}
      .svc-grid{grid-template-columns:1fr!important}
      .svc-sub{grid-template-columns:1fr!important}
      .port-grid{columns:2 160px!important}
      .hbadge{display:none!important}
      .svch{flex-direction:column!important}
      .porth{flex-direction:column!important}
      .frow{grid-template-columns:1fr!important}
    }
    @media(max-width:480px){
      .port-grid{columns:1!important}
      .hbtns{flex-direction:column!important}
    }
  `}</style>
);

/* ── REVEAL HOOK ── */
function useReveal() {
  useEffect(() => {
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => { if (e.isIntersecting) e.target.classList.add("vis"); });
    }, { threshold: 0.1 });
    document.querySelectorAll(".reveal,.reveal-l,.reveal-r").forEach(el => obs.observe(el));
    return () => obs.disconnect();
  });
}

/* ── SECTION TAG ── */
const Tag = ({ text, center = false }) => (
  <div style={{ display:"flex",alignItems:"center",gap:"12px",marginBottom:"20px",justifyContent:center?"center":"flex-start" }}>
    <div style={{ width:"36px",height:"1px",background:C.gold }}/>
    <span style={{ fontSize:"10px",letterSpacing:"0.35em",textTransform:"uppercase",color:C.gold }}>{text}</span>
    {center && <div style={{ width:"36px",height:"1px",background:C.gold }}/>}
  </div>
);

/* ── INSTAGRAM SVG ── */
const IgSvg = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const YtSvg = () => (
  <svg width="15" height="15" viewBox="0 0 24 24" fill="currentColor">
    <path d="M23.495 6.205a3.007 3.007 0 0 0-2.088-2.088c-1.87-.501-9.396-.501-9.396-.501s-7.507-.01-9.396.501A3.007 3.007 0 0 0 .527 6.205a31.247 31.247 0 0 0-.522 5.805 31.247 31.247 0 0 0 .522 5.783 3.007 3.007 0 0 0 2.088 2.088c1.868.502 9.396.502 9.396.502s7.506 0 9.396-.502a3.007 3.007 0 0 0 2.088-2.088 31.247 31.247 0 0 0 .5-5.783 31.247 31.247 0 0 0-.5-5.805zM9.609 15.601V8.408l6.264 3.602z"/>
  </svg>
);

/* ══════════════════════════════════════════
   SECTIONS
══════════════════════════════════════════ */

function Nav({ scrolled, onNav }) {
  const [open, setOpen] = useState(false);
  const s = {
    nav: {
      position:"fixed",top:0,left:0,right:0,zIndex:1000,
      display:"flex",alignItems:"center",justifyContent:"space-between",
      padding:"0 5vw",
      height:scrolled?"66px":"90px",
      background:scrolled?"rgba(8,8,8,0.96)":"transparent",
      backdropFilter:scrolled?"blur(20px)":"none",
      borderBottom:scrolled?`1px solid ${C.border}`:"none",
      transition:"all 0.5s ease",
    },
  };
  return (
    <>
      <nav style={s.nav}>
        <div onClick={() => onNav("home")} style={{ cursor:"pointer",display:"flex",alignItems:"center" }}>
          <img src={Logo} alt="DesignUp" style={{ height:"60px",objectFit:"contain" }}/>
        </div>
        <div className="nav-d" style={{ display:"flex",alignItems:"center",gap:"36px" }}>
          {NAV_ITEMS.map(n => (
            <span key={n} className="nav-link" onClick={() => onNav(n.toLowerCase())}
              style={{ fontSize:"10px",letterSpacing:"0.22em",textTransform:"uppercase",color:"rgba(245,240,235,0.65)",cursor:"pointer",transition:"color 0.3s" }}>
              {n}
            </span>
          ))}
          <button className="btn-gold" onClick={() => onNav("contact")}
            style={{ background:C.gold,color:"#080808",border:`1px solid ${C.gold}`,padding:"11px 26px",fontSize:"10px",letterSpacing:"0.2em",textTransform:"uppercase",fontWeight:"600",cursor:"pointer",fontFamily:"Outfit,sans-serif",transition:"all 0.35s" }}>
            Book Consultation
          </button>
        </div>
        <div className="ham" onClick={() => setOpen(!open)}
          style={{ display:"none",flexDirection:"column",gap:"6px",cursor:"pointer",padding:"4px" }}>
          <span style={{ display:"block",width:"24px",height:"1.5px",background:C.white }}/>
          <span style={{ display:"block",width:"24px",height:"1.5px",background:C.white }}/>
          <span style={{ display:"block",width:"24px",height:"1.5px",background:C.white }}/>
        </div>
      </nav>
      {open && (
        <div style={{ position:"fixed",inset:0,zIndex:990,background:"rgba(8,8,8,0.98)",backdropFilter:"blur(30px)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:"36px" }}>
          <span onClick={() => setOpen(false)} style={{ position:"absolute",top:"24px",right:"5vw",fontSize:"32px",color:C.muted,cursor:"pointer" }}>✕</span>
          {NAV_ITEMS.map((n,i) => (
            <div key={n} onClick={() => { onNav(n.toLowerCase()); setOpen(false); }}
              style={{ fontFamily:"'Playfair Display',serif",fontSize:"clamp(32px,8vw,56px)",color:C.white,cursor:"pointer",animation:`fadeUp 0.5s ease ${i*0.07}s both` }}>
              {n}
            </div>
          ))}
        </div>
      )}
    </>
  );
}

function Hero({ onNav }) {
  return (
    <section id="home" style={{ height:"100vh",minHeight:"600px",position:"relative",display:"flex",alignItems:"center",overflow:"hidden" }}>
      <div style={{ position:"absolute",inset:0,backgroundImage:`url('${IMGS.hero}')`,backgroundSize:"cover",backgroundPosition:"center",animation:"kenBurns 14s ease-in-out infinite alternate" }}/>
      <div style={{ position:"absolute",inset:0,background:"linear-gradient(105deg,rgba(8,8,8,0.92) 0%,rgba(8,8,8,0.55) 55%,rgba(8,8,8,0.25) 100%)" }}/>
      <div style={{ position:"relative",zIndex:2,padding:"0 5vw",maxWidth:"900px" }}>
        <div style={{ display:"flex",alignItems:"center",gap:"12px",marginBottom:"28px",animation:"fadeUp 0.8s ease 0.2s both" }}>
          <div style={{ width:"40px",height:"1px",background:C.gold }}/>
          <span style={{ fontSize:"10px",letterSpacing:"0.4em",textTransform:"uppercase",color:C.gold }}>Hyderabad's Premier Design Studio</span>
        </div>
        <h1 style={{ fontFamily:"'Playfair Display',serif",fontSize:"clamp(48px,9vw,118px)",fontWeight:"900",lineHeight:"0.93",marginBottom:"32px",animation:"fadeUp 0.9s ease 0.4s both" }}>
          <span style={{ display:"block",color:C.white }}>Where Space</span>
          <span style={{ display:"block",color:C.gold,fontStyle:"italic" }}>Becomes Art.</span>
        </h1>
        <p style={{ fontSize:"clamp(14px,1.6vw,17px)",color:"rgba(245,240,235,0.5)",fontWeight:"300",lineHeight:"1.95",maxWidth:"460px",marginBottom:"48px",letterSpacing:"0.04em",animation:"fadeUp 1s ease 0.6s both" }}>
        We specialize in interior design, renovations, and turnkey project execution for residential and commercial spaces. Our team focuses on creating functional, elegant, and personalized interiors that reflect your lifestyle.        </p>
        <div className="hbtns" style={{ display:"flex",gap:"16px",flexWrap:"wrap",animation:"fadeUp 1.1s ease 0.8s both" }}>
          <button className="btn-gold" onClick={() => onNav("portfolio")}
            style={{ background:C.gold,color:"#080808",border:`1px solid ${C.gold}`,padding:"16px 44px",fontSize:"11px",letterSpacing:"0.2em",textTransform:"uppercase",fontWeight:"700",cursor:"pointer",fontFamily:"Outfit,sans-serif",transition:"all 0.35s" }}>
            Explore Our Work
          </button>
          <button className="btn-ol" onClick={() => onNav("contact")}
            style={{ background:"transparent",color:C.gold,border:`1px solid ${C.gold}`,padding:"16px 44px",fontSize:"11px",letterSpacing:"0.2em",textTransform:"uppercase",fontWeight:"500",cursor:"pointer",fontFamily:"Outfit,sans-serif",transition:"all 0.35s" }}>
            Get Consultation
          </button>
        </div>
      </div>
      <div className="hbadge" style={{ position:"absolute",right:"5vw",top:"50%",transform:"translateY(-50%)",width:"clamp(140px,15vw,185px)",height:"clamp(140px,15vw,185px)",border:`1px solid ${C.border}`,borderRadius:"50%",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",background:"rgba(8,8,8,0.55)",backdropFilter:"blur(12px)",animation:"floatAnim 6s ease-in-out infinite",zIndex:2 }}>
        <div style={{ fontFamily:"'Playfair Display',serif",fontSize:"clamp(30px,4vw,42px)",fontWeight:"700",color:C.gold,lineHeight:"1" }}>9+</div>
        <div style={{ fontSize:"9px",letterSpacing:"0.25em",textTransform:"uppercase",color:C.muted,textAlign:"center",marginTop:"6px" }}>Years of<br/>Excellence</div>
      </div>
      <div style={{ position:"absolute",bottom:"36px",left:"50%",transform:"translateX(-50%)",display:"flex",flexDirection:"column",alignItems:"center",gap:"8px",zIndex:2 }}>
        <div style={{ width:"1px",height:"60px",background:`linear-gradient(to bottom,${C.gold},transparent)`,animation:"pulseAnim 2s ease-in-out infinite" }}/>
        <span style={{ fontSize:"9px",letterSpacing:"0.35em",textTransform:"uppercase",color:C.muted }}>Scroll</span>
      </div>
    </section>
  );
}

function Marquee() {
  const txt = "✦ Residential Design · Modular Kitchen · Villa Interiors · Office Spaces · Hospitality · 3D Visualization · Custom Furniture · Space Planning";
  return (
    <div style={{ background:C.gold,padding:"14px 0",overflow:"hidden" }}>
      <div style={{ display:"flex",width:"max-content",animation:"marqueeAnim 26s linear infinite",fontSize:"11px",letterSpacing:"0.25em",textTransform:"uppercase",color:"#080808",fontWeight:"600",whiteSpace:"nowrap" }}>
        {Array(6).fill(txt).map((t,i) => <span key={i} style={{ padding:"0 40px" }}>{t}</span>)}
      </div>
    </div>
  );
}


function About({ onNav }) {
  const focusPoints = [
    "Smart space planning",
    "Quality materials and finishes",
    "Timely project execution",
    "Transparent costing",
    "Client satisfaction",
  ];

  return (
    <section id="about" style={{ padding:"clamp(80px,10vw,140px) 5vw", background:C.bg2 }}>
      <div className="about-inner" style={{
        maxWidth:"1300px", margin:"0 auto", display:"flex",
        gap:"clamp(48px,8vw,100px)", alignItems:"stretch",   
      }}>

        {/* ── Left: images — height now tracks content ── */}
        <div className="about-imgs reveal-l" style={{
          flex:"0 0 50%", position:"relative",
          alignSelf:"stretch", minHeight:"460px",            
        }}>
          <img src={IMGS.about1} alt="Interior" style={{
            position:"absolute", top:0, left:0,
            width:"72%", height:"92%",                       
            objectFit:"cover", boxShadow:"30px 30px 80px rgba(0,0,0,0.6)",
          }}/>
          <img src={IMGS.about2} alt="Detail" style={{
            position:"absolute", bottom:0, right:0,
            width:"48%", height:"48%",
            objectFit:"cover", border:`6px solid ${C.bg2}`,
            boxShadow:"0 20px 60px rgba(0,0,0,0.5)",
          }}/>
          <div style={{
            position:"absolute", bottom:"44px", left:"44px",
            background:C.gold, padding:"20px 28px",
            fontFamily:"'Playfair Display',serif",
          }}>
            <div style={{ fontSize:"clamp(30px,4.5vw,46px)", fontWeight:"700", color:"#080808", lineHeight:"1" }}>80+</div>
            <div style={{ fontSize:"9px", letterSpacing:"0.22em", textTransform:"uppercase", color:"rgba(8,8,8,0.55)", marginTop:"4px" }}>Projects Done</div>
          </div>
        </div>

        {/* ── Right: copy ── */}
        <div className="reveal-r" style={{ flex:1 }}>
          <Tag text="Our Studio"/>
          <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:"clamp(34px,5vw,64px)", fontWeight:"700", lineHeight:"1.05", letterSpacing:"-0.01em", marginBottom:"28px" }}>
            Design That<br/><em style={{ color:C.gold }}>Tells Your Story</em>
          </h2>

          <p style={{ fontSize:"clamp(14px,1.5vw,16px)", color:"rgba(245,240,235,0.5)", fontWeight:"300", lineHeight:"2", marginBottom:"18px", letterSpacing:"0.03em" }}>
            DesignUp Interiors is a professional interior design and renovation company dedicated to transforming spaces into functional and aesthetically pleasing environments. We provide complete interior solutions — from planning to final execution.
          </p>
          <p style={{ fontSize:"clamp(14px,1.5vw,16px)", color:"rgba(245,240,235,0.5)", fontWeight:"300", lineHeight:"2", marginBottom:"18px", letterSpacing:"0.03em" }}>
            Our team works closely with clients to understand their requirements and deliver designs that combine creativity, practicality, and quality workmanship.
          </p>
          <p style={{ fontSize:"clamp(14px,1.5vw,16px)", color:"rgba(245,240,235,0.5)", fontWeight:"300", lineHeight:"2", marginBottom:"32px", letterSpacing:"0.03em" }}>
            Whether it is a new home interior, renovation project, or commercial space — we ensure every project is completed with attention to detail and the highest standards.
          </p>

          {/* Our Focus */}
          <div style={{ borderTop:`1px solid ${C.border}`, borderBottom:`1px solid ${C.border}`, padding:"24px 0", marginBottom:"32px" }}>
            <div style={{ fontSize:"9px", letterSpacing:"0.35em", textTransform:"uppercase", color:C.gold, marginBottom:"16px" }}>Our Focus</div>
            <div style={{ display:"flex", flexDirection:"column", gap:"10px" }}>
              {focusPoints.map((point, i) => (
                <div key={i} style={{ display:"flex", alignItems:"center", gap:"14px" }}>
                  <div style={{ width:"6px", height:"6px", background:C.gold, transform:"rotate(45deg)", flexShrink:0 }}/>
                  <span style={{ fontSize:"clamp(13px,1.4vw,15px)", color:"rgba(245,240,235,0.55)", fontWeight:"300", letterSpacing:"0.04em" }}>{point}</span>
                </div>
              ))}
            </div>
          </div>

          <div style={{ display:"flex", gap:"10px", flexWrap:"wrap", marginBottom:"36px" }}>
            {["9+ Years","Award Winning","Pan-India","100% Bespoke"].map(t => (
              <span key={t} style={{ padding:"8px 18px", border:`1px solid ${C.border}`, fontSize:"10px", letterSpacing:"0.14em", color:C.muted, textTransform:"uppercase" }}>{t}</span>
            ))}
          </div>

          <button className="btn-gold" onClick={() => onNav("contact")}
            style={{ background:C.gold, color:"#080808", border:`1px solid ${C.gold}`, padding:"15px 40px", fontSize:"11px", letterSpacing:"0.2em", textTransform:"uppercase", fontWeight:"700", cursor:"pointer", fontFamily:"Outfit,sans-serif", transition:"all 0.35s" }}>
            Work With Us
          </button>
        </div>

      </div>
    </section>
  );
}
function Stats() {

  const data = [
    { n:"80+", l:"Projects Completed" },
    { n:"98%", l:"Client Satisfaction" },
    { n:"9+", l:"Years Experience" },
    { n:"1",   l:"Expert Designer" },
  ];
  return (
    <div style={{ background:"linear-gradient(135deg,#131313 0%,#0a0a0a 100%)",borderTop:`1px solid ${C.border}`,borderBottom:`1px solid ${C.border}`,padding:"clamp(50px,6vw,80px) 5vw" }}>
      <div className="stats-grid reveal" style={{ display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:"clamp(20px,4vw,48px)",maxWidth:"1100px",margin:"0 auto",textAlign:"center" }}>
        {data.map(s => (
          <div key={s.l}>
            <div style={{ fontFamily:"'Playfair Display',serif",fontSize:"clamp(42px,6vw,76px)",fontWeight:"700",color:C.gold,lineHeight:"1",marginBottom:"10px" }}>{s.n}</div>
            <div style={{ fontSize:"10px",letterSpacing:"0.22em",textTransform:"uppercase",color:C.muted }}>{s.l}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Services() {
  return (
    <section id="services" style={{ padding:"clamp(80px,10vw,130px) 5vw",background:C.bg }}>
      <div style={{ maxWidth:"1400px",margin:"0 auto" }}>
        <div className="reveal"><Tag text="What We Do"/></div>
        <div className="svch reveal" style={{ display:"flex",justifyContent:"space-between",alignItems:"flex-end",flexWrap:"wrap",gap:"20px",marginBottom:"clamp(40px,6vw,70px)" }}>
          <h2 style={{ fontFamily:"'Playfair Display',serif",fontSize:"clamp(34px,5vw,64px)",fontWeight:"700",lineHeight:"1.05",letterSpacing:"-0.01em" }}>
            Our<br/><em style={{ color:C.gold }}>Specialisations</em>
          </h2>
          <p style={{ fontSize:"clamp(13px,1.4vw,15px)",color:"rgba(245,240,235,0.4)",fontWeight:"300",lineHeight:"1.9",maxWidth:"380px",letterSpacing:"0.04em" }}>
            From intimate residences to grand hospitality experiences — we design spaces that resonate, in Hyderabad and beyond.
          </p>
        </div>
        <div className="svc-grid" style={{ display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"24px",marginBottom:"40px" }}>
          {SERVICES_MAIN.map(s => (
            <div key={s.n} className="svc-card reveal" style={{ background:C.card,border:`1px solid ${C.border}`,overflow:"hidden",cursor:"pointer",transition:"all 0.4s ease" }}>
              <div style={{ overflow:"hidden",height:"220px" }}>
                <img className="svc-img" src={s.img} alt={s.title} style={{ width:"100%",height:"100%",objectFit:"cover",transition:"transform 0.6s ease" }}/>
              </div>
              <div style={{ padding:"28px" }}>
                <div style={{ fontFamily:"'Playfair Display',serif",fontSize:"36px",fontWeight:"700",color:"rgba(200,169,110,0.15)",lineHeight:"1",marginBottom:"4px" }}>{s.n}</div>
                <div style={{ fontSize:"9px",letterSpacing:"0.3em",textTransform:"uppercase",color:C.gold,marginBottom:"8px" }}>{s.sub}</div>
                <h3 style={{ fontFamily:"'Playfair Display',serif",fontSize:"clamp(18px,2.2vw,24px)",fontWeight:"600",marginBottom:"12px" }}>{s.title}</h3>
                <p style={{ fontSize:"13px",color:"rgba(245,240,235,0.4)",lineHeight:"1.8",fontWeight:"300" }}>{s.desc}</p>
                <div style={{ marginTop:"20px",fontSize:"11px",letterSpacing:"0.15em",textTransform:"uppercase",color:C.gold }}>Explore →</div>
              </div>
            </div>
          ))}
        </div>
        <div className="svc-sub reveal" style={{ display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"24px",background:C.bg2,border:`1px solid ${C.border}`,padding:"36px" }}>
          {SERVICES_LIST.map(col => (
            <div key={col.head}>
              <h4 style={{ fontSize:"9px",letterSpacing:"0.3em",textTransform:"uppercase",color:C.gold,marginBottom:"16px",paddingBottom:"10px",borderBottom:`1px solid ${C.border}` }}>{col.head}</h4>
              {col.items.map(item => (
                <div key={item} className="sub-item" style={{ fontSize:"13px",color:"rgba(245,240,235,0.45)",fontWeight:"300",padding:"8px 0",borderBottom:"1px solid rgba(255,255,255,0.04)",display:"flex",alignItems:"center",gap:"10px",letterSpacing:"0.03em",transition:"color 0.3s",cursor:"default" }}>
                  <span style={{ fontSize:"5px",color:C.gold,flexShrink:0 }}>◆</span>{item}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function Portfolio() {
  const [filter, setFilter] = useState("All");
  const filtered = filter === "All" ? PORTFOLIO : PORTFOLIO.filter(p => p.tag === filter);
  return (
    <section id="portfolio" style={{ padding:"clamp(80px,10vw,130px) 5vw",background:C.bg2 }}>
      <div style={{ maxWidth:"1400px",margin:"0 auto" }}>
        <div className="porth" style={{ display:"flex",justifyContent:"space-between",alignItems:"flex-end",flexWrap:"wrap",gap:"24px",marginBottom:"48px" }}>
          <div className="reveal">
            <Tag text="Our Work"/>
            <h2 style={{ fontFamily:"'Playfair Display',serif",fontSize:"clamp(34px,5vw,64px)",fontWeight:"700",lineHeight:"1.05",letterSpacing:"-0.01em",marginBottom:"0" }}>
              Selected<br/><em style={{ color:C.gold }}>Projects</em>
            </h2>
          </div>
          <div className="reveal" style={{ display:"flex",gap:"8px",flexWrap:"wrap" }}>
            {FILTERS.map(f => (
              <button key={f} className={`filter-btn${filter===f?" active":""}`} onClick={() => setFilter(f)}
                style={{ padding:"9px 20px",fontSize:"10px",letterSpacing:"0.18em",textTransform:"uppercase",fontFamily:"Outfit,sans-serif",cursor:"pointer",border:"1px solid",borderColor:filter===f?C.gold:C.border,background:filter===f?C.gold:"transparent",color:filter===f?"#080808":C.muted,transition:"all 0.3s ease" }}>
                {f}
              </button>
            ))}
          </div>
        </div>
        <div className="port-grid" style={{ columns:"4 240px",gap:"16px" }}>
          {filtered.map((p,i) => (
            <div key={p.id} className="p-item reveal" style={{ breakInside:"avoid",marginBottom:"16px",position:"relative",overflow:"hidden",cursor:"pointer" }}>
              <img className="p-img" src={p.img} alt={p.title}
                style={{ width:"100%",display:"block",aspectRatio:i%3===0?"3/4":"4/3",objectFit:"cover",transition:"transform 0.7s cubic-bezier(0.25,0.46,0.45,0.94)" }}/>
              <div className="p-ov" style={{ position:"absolute",inset:0,background:"linear-gradient(to top,rgba(8,8,8,0.95) 0%,rgba(8,8,8,0.3) 60%,transparent 100%)",opacity:"0.35",transition:"opacity 0.4s ease",padding:"clamp(14px,2vw,24px)",display:"flex",flexDirection:"column",justifyContent:"flex-end" }}>
                <span style={{ fontSize:"9px",letterSpacing:"0.28em",textTransform:"uppercase",color:C.gold,marginBottom:"5px" }}>{p.tag} · {p.year}</span>
                <div style={{ fontFamily:"'Playfair Display',serif",fontSize:"clamp(14px,1.8vw,18px)",color:C.white,fontWeight:"500",marginBottom:"3px" }}>{p.title}</div>
                <div style={{ fontSize:"10px",color:"rgba(245,240,235,0.35)",letterSpacing:"0.06em" }}>📍 {p.loc}</div>
                <div className="p-arrow" style={{ marginTop:"10px",fontSize:"10px",letterSpacing:"0.2em",textTransform:"uppercase",color:C.gold,transform:"translateX(-18px)",opacity:0,transition:"all 0.35s ease" }}>View Project →</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

function QuoteBanner({ onNav }) {
  return (
    <div style={{ position:"relative",height:"clamp(300px,45vw,580px)",overflow:"hidden" }}>
      <img src={IMGS.fullwidth} alt="Interior" style={{ width:"100%",height:"100%",objectFit:"cover",transform:"scale(1.04)" }}/>
      <div style={{ position:"absolute",inset:0,background:"rgba(8,8,8,0.58)",display:"flex",alignItems:"center",justifyContent:"center" }}>
        <div className="reveal" style={{ textAlign:"center" }}>
          <h3 style={{ fontFamily:"'Playfair Display',serif",fontSize:"clamp(24px,4vw,58px)",fontWeight:"400",fontStyle:"italic",color:C.white,lineHeight:"1.3",marginBottom:"24px" }}>
            "Every great space begins<br/>with a <span style={{ color:C.gold }}>conversation.</span>"
          </h3>
          <button className="btn-gold" onClick={() => onNav("contact")}
            style={{ background:C.gold,color:"#080808",border:`1px solid ${C.gold}`,padding:"14px 40px",fontSize:"11px",letterSpacing:"0.2em",textTransform:"uppercase",fontWeight:"700",cursor:"pointer",fontFamily:"Outfit,sans-serif",transition:"all 0.35s" }}>
            Start Your Journey
          </button>
        </div>
      </div>
    </div>
  );
}

function Team() {
  const t = TEAM[0];
  return (
    <section id="team" style={{ padding:"clamp(80px,10vw,140px) 5vw", background:C.bg, position:"relative", overflow:"hidden" }}>

      {/* ── Large decorative initial ── */}
      <div style={{
        position:"absolute", right:"-2vw", top:"50%", transform:"translateY(-50%)",
        fontFamily:"'Playfair Display',serif", fontSize:"clamp(280px,35vw,480px)",
        fontWeight:"900", color:"rgba(200,169,110,0.04)", lineHeight:"1",
        userSelect:"none", pointerEvents:"none", letterSpacing:"-0.04em",
      }}>
        {t.initials}
      </div>

      <div style={{ maxWidth:"1300px", margin:"0 auto", position:"relative" }}>

        {/* ── Section tag ── */}
        <div className="reveal"><Tag text="The Creative Mind"/></div>

        {/* ── Two-column layout ── */}
        <div style={{ display:"flex", gap:"clamp(48px,8vw,120px)", alignItems:"flex-start", flexWrap:"wrap" }}>

          {/* LEFT — identity block */}
          <div className="reveal-l" style={{ flex:"0 0 clamp(240px,32%,380px)", paddingTop:"8px" }}>

            {/* Monogram medallion */}
            <div style={{ position:"relative", width:"clamp(130px,16vw,190px)", height:"clamp(130px,16vw,190px)", marginBottom:"clamp(28px,4vw,44px)" }}>
              {/* Outer ring — thin gold */}
              <div style={{
                position:"absolute", inset:0, borderRadius:"50%",
                border:`1px solid rgba(200,169,110,0.35)`,
                animation:"floatAnim 7s ease-in-out infinite",
              }}/>
              {/* Middle ring — dashed */}
              <div style={{
                position:"absolute", inset:"10px", borderRadius:"50%",
                border:`1px dashed rgba(200,169,110,0.18)`,
              }}/>
              {/* Filled core */}
              <div style={{
                position:"absolute", inset:"22px", borderRadius:"50%",
                background:`linear-gradient(135deg, ${C.gold} 0%, #7a5428 100%)`,
                display:"flex", alignItems:"center", justifyContent:"center",
                boxShadow:`0 20px 60px rgba(200,169,110,0.25)`,
              }}>
                <span style={{
                  fontFamily:"'Playfair Display',serif",
                  fontSize:"clamp(36px,6vw,62px)", fontWeight:"700",
                  color:"#080808", lineHeight:"1",
                }}>
                  {t.initials}
                </span>
              </div>
              {/* Orbiting dot */}
              <div style={{
                position:"absolute", top:"6px", left:"50%", transform:"translateX(-50%)",
                width:"6px", height:"6px", borderRadius:"50%", background:C.gold,
                boxShadow:`0 0 10px ${C.gold}`,
              }}/>
            </div>

            {/* Name + role */}
            <h2 style={{
              fontFamily:"'Playfair Display',serif",
              fontSize:"clamp(32px,4.5vw,52px)", fontWeight:"700",
              lineHeight:"1.05", letterSpacing:"-0.01em",
              marginBottom:"10px",
            }}>
              {t.name}
            </h2>
            <div style={{
              fontSize:"9px", letterSpacing:"0.35em", textTransform:"uppercase",
              color:C.gold, marginBottom:"20px", fontWeight:"500",
            }}>
              {t.role}
            </div>

            {/* Experience pill */}
            <div style={{
              display:"inline-flex", alignItems:"center", gap:"10px",
              padding:"9px 20px", border:`1px solid ${C.border}`,
              marginBottom:"32px",
            }}>
              <div style={{ width:"5px", height:"5px", borderRadius:"50%", background:C.gold, animation:"pulseAnim 2s ease-in-out infinite" }}/>
              <span style={{ fontSize:"10px", letterSpacing:"0.2em", textTransform:"uppercase", color:C.muted }}>{t.exp} of Practice</span>
            </div>

            {/* Accolade strip */}
            <div style={{ display:"flex", flexDirection:"column", gap:"8px" }}>
              {t.accolades.map(a => (
                <div key={a} style={{ display:"flex", alignItems:"center", gap:"12px" }}>
                  <div style={{ width:"24px", height:"1px", background:C.gold, flexShrink:0 }}/>
                  <span style={{ fontSize:"11px", letterSpacing:"0.12em", color:"rgba(245,240,235,0.38)", textTransform:"uppercase" }}>{a}</span>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT — editorial content */}
          <div className="reveal-r" style={{ flex:1, minWidth:"260px", paddingTop:"clamp(0px,2vw,16px)" }}>

            {/* Pull quote */}
            <div style={{
              borderLeft:`2px solid ${C.gold}`, paddingLeft:"clamp(20px,3vw,36px)",
              marginBottom:"clamp(32px,4vw,52px)",
            }}>
              <div style={{ fontSize:"clamp(20px,2.8vw,32px)", fontFamily:"'Playfair Display',serif", fontStyle:"italic", color:"rgba(245,240,235,0.82)", lineHeight:"1.45", letterSpacing:"0.01em" }}>
                "{t.tagline}"
              </div>
            </div>

            {/* Philosophy paragraph */}
            <p style={{
              fontSize:"clamp(14px,1.5vw,16.5px)", color:"rgba(245,240,235,0.42)",
              fontWeight:"300", lineHeight:"2.1", letterSpacing:"0.04em",
              marginBottom:"clamp(32px,4vw,52px)", maxWidth:"600px",
            }}>
              {t.philosophy}
            </p>

            {/* Expertise divider header */}
            <div style={{ display:"flex", alignItems:"center", gap:"16px", marginBottom:"20px" }}>
              <div style={{ width:"28px", height:"1px", background:C.gold }}/>
              <span style={{ fontSize:"9px", letterSpacing:"0.35em", textTransform:"uppercase", color:C.gold }}>Areas of Mastery</span>
              <div style={{ flex:1, height:"1px", background:"rgba(200,169,110,0.12)" }}/>
            </div>

            {/* Expertise tag cloud */}
            <div style={{ display:"flex", flexWrap:"wrap", gap:"10px", marginBottom:"clamp(36px,5vw,60px)" }}>
              {t.expertise.map((ex, i) => (
                <span key={ex} style={{
                  padding:"9px 20px",
                  background: i === 0 ? C.gold : "transparent",
                  border:`1px solid ${i === 0 ? C.gold : C.border}`,
                  color: i === 0 ? "#080808" : "rgba(245,240,235,0.42)",
                  fontSize:"10px", letterSpacing:"0.16em", textTransform:"uppercase",
                  fontWeight: i === 0 ? "700" : "300",
                  transition:"all 0.3s",
                }}>
                  {ex}
                </span>
              ))}
            </div>

            {/* Horizontal stat bar */}
            <div style={{
              display:"grid", gridTemplateColumns:"repeat(3,1fr)",
              borderTop:`1px solid ${C.border}`, borderLeft:`1px solid ${C.border}`,
            }}>
              {[
                { n:"80+", l:"Projects" },
                { n:"9",   l:"Years" },
                { n:"100%", l:"Bespoke" },
              ].map(s => (
                <div key={s.l} style={{
                  padding:"clamp(18px,2.5vw,28px) clamp(16px,2.5vw,28px)",
                  borderRight:`1px solid ${C.border}`, borderBottom:`1px solid ${C.border}`,
                  textAlign:"center",
                }}>
                  <div style={{ fontFamily:"'Playfair Display',serif", fontSize:"clamp(28px,4vw,44px)", fontWeight:"700", color:C.gold, lineHeight:"1", marginBottom:"6px" }}>{s.n}</div>
                  <div style={{ fontSize:"9px", letterSpacing:"0.25em", textTransform:"uppercase", color:C.muted }}>{s.l}</div>
                </div>
              ))}
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}
function Testimonials() {
  return (
    <div style={{ background:"linear-gradient(135deg,#0a0a0a 0%,#131313 100%)",borderTop:`1px solid ${C.border}`,padding:"clamp(80px,10vw,130px) 5vw" }}>
      <div style={{ maxWidth:"1200px",margin:"0 auto" }}>
        <div className="reveal" style={{ textAlign:"center",marginBottom:"clamp(48px,6vw,80px)" }}>
          <Tag text="Testimonials" center={true}/>
          <h2 style={{ fontFamily:"'Playfair Display',serif",fontSize:"clamp(34px,5vw,64px)",fontWeight:"700",lineHeight:"1.05" }}>
            Words From<br/><em style={{ color:C.gold }}>Our Clients</em>
          </h2>
        </div>
        <div className="tgrid" style={{ display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:"clamp(16px,3vw,28px)" }}>
          {TESTIMONIALS.map((t,i) => (
            <div key={t.name} className="reveal" style={{ background:C.card,border:`1px solid ${C.border}`,padding:"clamp(28px,4vw,48px)",position:"relative",animationDelay:`${i*0.15}s` }}>
              <div style={{ position:"absolute",top:"20px",right:"24px",fontFamily:"'Playfair Display',serif",fontSize:"80px",color:"rgba(200,169,110,0.1)",lineHeight:"1",userSelect:"none" }}>"</div>
              <div style={{ color:C.gold,letterSpacing:"3px",fontSize:"13px",marginBottom:"18px" }}>★★★★★</div>
              <p style={{ fontFamily:"'Playfair Display',serif",fontStyle:"italic",fontSize:"clamp(14px,1.6vw,17px)",color:"rgba(245,240,235,0.75)",lineHeight:"1.8",marginBottom:"24px" }}>"{t.quote}"</p>
              <div style={{ display:"flex",alignItems:"center",gap:"14px" }}>
                <div style={{ width:"44px",height:"44px",borderRadius:"50%",flexShrink:0,background:`linear-gradient(135deg,${C.gold},#7a5c2e)`,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Playfair Display',serif",fontWeight:"700",fontSize:"15px",color:"#080808" }}>{t.initial}</div>
                <div>
                  <div style={{ fontFamily:"'Playfair Display',serif",fontSize:"15px",fontWeight:"600",marginBottom:"3px" }}>{t.name}</div>
                  <div style={{ fontSize:"10px",letterSpacing:"0.12em",color:C.muted,textTransform:"uppercase" }}>{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

function Contact() {
  const WAYS = [
    {
      icon: "📞",
      label: "Call / WhatsApp",
      val: "+91 73374 41369",
      sub: "Mon – Sat · 10 AM – 7 PM",
      href: "https://wa.me/917337441369?text=Hi%20DesignUp%2C%20I%27d%20like%20to%20discuss%20an%20interior%20project.",
      cta: "Open WhatsApp →",
      accent: "#25D366",
    },
    {
      icon: "✉️",
      label: "Email Us",
      val: "designupinteriorsteam@gmail.com",
      sub: "We reply within 24 hours",
      href: "mailto:designupinteriorsteam@gmail.com?subject=Interior%20Design%20Enquiry",
      cta: "Send Email →",
      accent: C.gold,
    },
    {
      icon: "📍",
      label: "Visit Our Studio",
      val: "Gachibowli, Hyderabad",
      sub: "Telangana · India",
      href: "https://maps.google.com/?q=Gachibowli+Hyderabad",
      cta: "Get Directions →",
      accent: C.gold,
    },
    {
      icon: "📸",
      label: "Follow on Instagram",
      val: "@designup_interiors",
      sub: "Project reveals · Behind the scenes",
      href: "https://www.instagram.com/designup_interiors?igsh=MWY1a3dpbHR6azFleA==",
      cta: "View Profile →",
      accent: "#E1306C",
    },
  ];

  const BUDGETS = ["₹5L – ₹15L", "₹15L – ₹30L", "₹30L – ₹60L", "₹60L+"];

  return (
    <section id="contact" style={{ padding: "clamp(80px,10vw,140px) 5vw", background: C.bg2, position: "relative", overflow: "hidden" }}>

      {/* Decorative BG orb */}
      <div style={{ position: "absolute", top: "-120px", right: "-120px", width: "500px", height: "500px", borderRadius: "50%", background: `radial-gradient(circle, rgba(200,169,110,0.06) 0%, transparent 70%)`, pointerEvents: "none" }} />
      <div style={{ position: "absolute", bottom: "-80px", left: "-80px", width: "320px", height: "320px", borderRadius: "50%", background: `radial-gradient(circle, rgba(200,169,110,0.04) 0%, transparent 70%)`, pointerEvents: "none" }} />

      <div style={{ maxWidth: "1300px", margin: "0 auto" }}>

        {/* ── HEADER ── */}
        <div className="reveal" style={{ textAlign: "center", marginBottom: "clamp(56px,7vw,96px)" }}>
          <Tag text="Let's Connect" center={true} />
          <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: "clamp(36px,5.5vw,72px)", fontWeight: "700", lineHeight: "1.02", letterSpacing: "-0.01em", marginBottom: "20px" }}>
            Let's Build Something<br /><em style={{ color: C.gold }}>Extraordinary Together</em>
          </h2>
          <p style={{ fontSize: "clamp(14px,1.5vw,16px)", color: "rgba(245,240,235,0.38)", fontWeight: "300", lineHeight: "2", maxWidth: "480px", margin: "0 auto", letterSpacing: "0.04em" }}>
            Every great space begins with a conversation. Reach out through any channel — we'd love to hear about your vision.
          </p>
        </div>

        {/* ── PRIMARY CTA STRIP ── */}
        <div className="reveal" style={{ background: `linear-gradient(115deg, ${C.gold} 0%, #8b6d3f 100%)`, padding: "clamp(28px,4vw,48px) clamp(28px,5vw,60px)", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: "24px", marginBottom: "clamp(28px,4vw,48px)" }}>
          <div>
            <div style={{ fontSize: "9px", letterSpacing: "0.35em", textTransform: "uppercase", color: "rgba(8,8,8,0.5)", marginBottom: "8px" }}>Ready to transform your space?</div>
            <div style={{ fontFamily: "'Playfair Display',serif", fontSize: "clamp(22px,3.5vw,40px)", fontWeight: "700", color: "#080808", lineHeight: "1.1" }}>Book a Free Consultation</div>
            <div style={{ fontSize: "13px", color: "rgba(8,8,8,0.45)", fontWeight: "300", marginTop: "6px", letterSpacing: "0.04em" }}>30-minute call · No obligation · Pan-India projects welcome</div>
          </div>
          <a href="https://wa.me/917337441369?text=Hi%20DesignUp%2C%20I%27d%20like%20to%20book%20a%20free%20consultation." target="_blank" rel="noopener noreferrer"
            style={{ background: "#080808", color: C.gold, border: "none", padding: "18px 44px", fontSize: "11px", letterSpacing: "0.22em", textTransform: "uppercase", fontWeight: "700", cursor: "pointer", fontFamily: "Outfit,sans-serif", textDecoration: "none", display: "inline-block", flexShrink: 0, transition: "opacity 0.3s" }}
            onMouseEnter={e => e.currentTarget.style.opacity = "0.85"}
            onMouseLeave={e => e.currentTarget.style.opacity = "1"}>
            WhatsApp Us ✦
          </a>
        </div>

        {/* ── 4 CHANNEL CARDS ── */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(240px,1fr))", gap: "clamp(14px,2vw,20px)", marginBottom: "clamp(40px,5vw,64px)" }}>
          {WAYS.map((w, i) => (
            <a key={w.label} href={w.href} target="_blank" rel="noopener noreferrer" className="reveal"
              style={{ background: C.card, border: `1px solid ${C.border}`, padding: "clamp(24px,3vw,36px)", textDecoration: "none", display: "block", position: "relative", overflow: "hidden", transition: "border-color 0.3s, transform 0.35s", animationDelay: `${i * 0.1}s` }}
              onMouseEnter={e => { e.currentTarget.style.borderColor = w.accent; e.currentTarget.style.transform = "translateY(-4px)"; }}
              onMouseLeave={e => { e.currentTarget.style.borderColor = C.border; e.currentTarget.style.transform = "translateY(0)"; }}>
              {/* Accent bar */}
              <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: "2px", background: w.accent, opacity: 0.7 }} />
              <div style={{ fontSize: "26px", marginBottom: "16px" }}>{w.icon}</div>
              <div style={{ fontSize: "9px", letterSpacing: "0.3em", textTransform: "uppercase", color: C.muted, marginBottom: "8px" }}>{w.label}</div>
              <div style={{ fontFamily: "'Playfair Display',serif", fontSize: "clamp(13px,1.4vw,15px)", color: C.white, fontWeight: "500", marginBottom: "5px", lineHeight: "1.5", wordBreak: "break-word" }}>{w.val}</div>
              <div style={{ fontSize: "11px", color: "rgba(245,240,235,0.28)", fontWeight: "300", marginBottom: "20px" }}>{w.sub}</div>
              <div style={{ fontSize: "10px", letterSpacing: "0.18em", textTransform: "uppercase", color: w.accent, fontWeight: "600" }}>{w.cta}</div>
            </a>
          ))}
        </div>

        {/* ── BOTTOM ROW: Budget hint + Location + Studio hours ── */}
        <div className="reveal" style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))", gap: "clamp(14px,2vw,20px)" }}>

          {/* Budget / Project type prompt */}
          <div style={{ background: C.bg3 || "#0d0d0d", border: `1px solid ${C.border}`, padding: "clamp(24px,3vw,36px)" }}>
            <div style={{ fontSize: "9px", letterSpacing: "0.3em", textTransform: "uppercase", color: C.gold, marginBottom: "16px" }}>We Work Across</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginBottom: "20px" }}>
              {["Residential", "Commercial", "Hospitality", "Villa", "Office", "Restaurant"].map(t => (
                <span key={t} style={{ padding: "6px 14px", border: `1px solid ${C.border}`, fontSize: "10px", letterSpacing: "0.12em", color: "rgba(245,240,235,0.4)", textTransform: "uppercase" }}>{t}</span>
              ))}
            </div>
            <div style={{ fontSize: "9px", letterSpacing: "0.3em", textTransform: "uppercase", color: C.gold, marginBottom: "12px" }}>Budget Ranges</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
              {BUDGETS.map(b => (
                <span key={b} style={{ padding: "6px 14px", border: `1px solid ${C.border}`, fontSize: "10px", color: "rgba(245,240,235,0.35)", letterSpacing: "0.06em" }}>{b}</span>
              ))}
            </div>
          </div>

          {/* Studio location card */}
          <div style={{ background: C.bg3 || "#0d0d0d", border: `1px solid ${C.border}`, padding: "clamp(24px,3vw,36px)", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
            <div>
              <div style={{ fontSize: "9px", letterSpacing: "0.3em", textTransform: "uppercase", color: C.gold, marginBottom: "16px" }}>Our Studio</div>
              <div style={{ fontFamily: "'Playfair Display',serif", fontSize: "clamp(18px,2.2vw,26px)", fontWeight: "600", color: C.white, lineHeight: "1.3", marginBottom: "10px" }}>Gachibowli,<br />Hyderabad</div>
              <div style={{ fontSize: "12px", color: "rgba(245,240,235,0.3)", fontWeight: "300", marginBottom: "6px", letterSpacing: "0.06em" }}>Telangana · India</div>
              <div style={{ fontSize: "12px", color: "rgba(245,240,235,0.28)", fontWeight: "300", letterSpacing: "0.06em" }}>Mon – Sat · 10 AM – 7 PM</div>
            </div>
            <a href="https://maps.google.com/?q=Gachibowli+Hyderabad" target="_blank" rel="noopener noreferrer"
              style={{ marginTop: "28px", display: "inline-block", fontSize: "10px", letterSpacing: "0.2em", textTransform: "uppercase", color: C.gold, textDecoration: "none", borderBottom: `1px solid rgba(200,169,110,0.3)`, paddingBottom: "4px", width: "fit-content" }}>
              Get Directions →
            </a>
          </div>

          {/* Social / Pan-India callout */}
          <div style={{ background: `linear-gradient(145deg,#0d0d0d 0%,#111008 100%)`, border: `1px solid ${C.border}`, padding: "clamp(24px,3vw,36px)", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
            <div>
              <div style={{ fontSize: "9px", letterSpacing: "0.3em", textTransform: "uppercase", color: C.gold, marginBottom: "16px" }}>Pan-India Projects</div>
              <div style={{ fontFamily: "'Playfair Display',serif", fontSize: "clamp(16px,2vw,22px)", fontWeight: "600", fontStyle: "italic", color: "rgba(245,240,235,0.8)", lineHeight: "1.5", marginBottom: "16px" }}>
                "Distance is no barrier to great design."
              </div>
              <div style={{ fontSize: "12px", color: "rgba(245,240,235,0.28)", fontWeight: "300", lineHeight: "1.9", letterSpacing: "0.04em" }}>
                We've delivered projects across Mumbai, Bengaluru, Chennai, Delhi and beyond — virtually and on-site.
              </div>
            </div>
            <div style={{ display: "flex", gap: "10px", marginTop: "28px" }}>
              <a href="https://www.instagram.com/designup_interiors?igsh=MWY1a3dpbHR6azFleA==" target="_blank" rel="noopener noreferrer" className="soc-btn"
                style={{ display: "flex", alignItems: "center", gap: "7px", padding: "10px 16px", border: `1px solid ${C.border}`, fontSize: "11px", color: "rgba(245,240,235,0.4)", cursor: "pointer", transition: "all 0.3s", textDecoration: "none", letterSpacing: "0.06em" }}>
                <IgSvg /> Instagram
              </a>
              <a href="https://youtube.com/@designup-interiors?si=a0mhbQFlbrJhNnhB" target="_blank" rel="noopener noreferrer" className="soc-btn"
                style={{ display: "flex", alignItems: "center", gap: "7px", padding: "10px 16px", border: `1px solid ${C.border}`, fontSize: "11px", color: "rgba(245,240,235,0.4)", cursor: "pointer", transition: "all 0.3s", textDecoration: "none", letterSpacing: "0.06em" }}>
                <YtSvg /> YouTube
              </a>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

function Footer({ onNav }) {
  return (
    <footer style={{ background:"#040404",borderTop:`1px solid ${C.border}`,padding:"clamp(56px,7vw,90px) 5vw 28px" }}>
      <div className="footer-grid" style={{ display:"grid",gridTemplateColumns:"2fr 1fr 1fr 1fr",gap:"clamp(32px,5vw,60px)",marginBottom:"56px" }}>
        <div>
          <img src={Logo} alt="DesignUp" style={{ height:"34px",objectFit:"contain",marginBottom:"8px",display:"block" }}/>
          <div style={{ fontSize:"9px",letterSpacing:"0.4em",textTransform:"uppercase",color:C.muted,marginBottom:"20px" }}>Interiors Studio · Hyderabad</div>
          <p style={{ fontSize:"13px",color:"rgba(245,240,235,0.25)",fontWeight:"300",lineHeight:"1.9",maxWidth:"280px",letterSpacing:"0.03em" }}>Creating soulful spaces that transcend trends. Your story, beautifully told through design, material, and light.</p>
          <div style={{ display:"flex",gap:"10px",marginTop:"24px" }}>
            {[
              { href:"https://www.instagram.com/designup_interiors?igsh=MWY1a3dpbHR6azFleA==", icon:<IgSvg/> },
              { href:"https://youtube.com/@designup-interiors?si=a0mhbQFlbrJhNnhB", icon:<YtSvg/> },
              { href:"tel:+917337441369", icon:"📞" },
            ].map((s,i) => (
              <a key={i} href={s.href} target="_blank" rel="noopener noreferrer" className="fsoc"
                style={{ width:"38px",height:"38px",border:`1px solid ${C.border}`,display:"flex",alignItems:"center",justifyContent:"center",cursor:"pointer",transition:"all 0.3s",color:C.muted,fontSize:"13px",textDecoration:"none" }}>
                {s.icon}
              </a>
            ))}
          </div>
        </div>
        <div>
          <div style={{ fontSize:"9px",letterSpacing:"0.3em",textTransform:"uppercase",color:C.gold,marginBottom:"20px",fontWeight:"500" }}>Navigate</div>
          {NAV_ITEMS.map(n => <div key={n} className="fl" onClick={() => onNav(n.toLowerCase())} style={{ fontSize:"13px",color:"rgba(245,240,235,0.3)",marginBottom:"10px",cursor:"pointer",fontWeight:"300",letterSpacing:"0.03em",transition:"color 0.3s" }}>{n}</div>)}
        </div>
        <div>
          <div style={{ fontSize:"9px",letterSpacing:"0.3em",textTransform:"uppercase",color:C.gold,marginBottom:"20px",fontWeight:"500" }}>Services</div>
          {["Residential Design","Villa Interiors","Modular Kitchen","Office Interiors","Restaurant Design","3D Visualization","Custom Furniture"].map(s => (
            <div key={s} className="fl" style={{ fontSize:"13px",color:"rgba(245,240,235,0.3)",marginBottom:"10px",cursor:"default",fontWeight:"300",letterSpacing:"0.03em",transition:"color 0.3s" }}>{s}</div>
          ))}
        </div>
        <div>
          <div style={{ fontSize:"9px",letterSpacing:"0.3em",textTransform:"uppercase",color:C.gold,marginBottom:"20px",fontWeight:"500" }}>Studio</div>
          <div className="fl" style={{ fontSize:"13px",color:"rgba(245,240,235,0.3)",marginBottom:"10px",fontWeight:"300",cursor:"default" }}>Gachibowli, Hyderabad</div>
          <a href="tel:+917337441369" className="fl" style={{ fontSize:"13px",color:"rgba(245,240,235,0.3)",marginBottom:"10px",fontWeight:"300",display:"block",textDecoration:"none" }}>+91 73374 41369</a>
          <a href="https://www.instagram.com/designup_interiors" target="_blank" rel="noopener noreferrer" className="fl" style={{ fontSize:"13px",color:"rgba(245,240,235,0.3)",marginBottom:"10px",fontWeight:"300",display:"block",textDecoration:"none" }}>designupinteriorsteam@gmail.com</a>
          <div className="fl" style={{ fontSize:"13px",color:"rgba(245,240,235,0.3)",marginBottom:"10px",fontWeight:"300",cursor:"default" }}>Mon–Sat 10am–7pm</div>
        </div>
      </div>
      <div style={{ borderTop:"1px solid rgba(255,255,255,0.05)",paddingTop:"24px",display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:"12px" }}>
        <div style={{ fontSize:"11px",color:"rgba(245,240,235,0.12)",letterSpacing:"0.06em" }}>© 2025 DesignUp Interiors. All Rights Reserved.</div>
        <div style={{ fontSize:"11px",color:"rgba(245,240,235,0.12)",letterSpacing:"0.06em" }}>Privacy Policy · Terms of Service</div>
      </div>
    </footer>
  );
}

/* ══════════════════════════════════════════
   MAIN APP
══════════════════════════════════════════ */
export default function DesignUp() {
  const [scrollY, setScrollY] = useState(0);
  const [cursor, setCursor]   = useState({ x:-100, y:-100 });

  useEffect(() => {
    const onScroll = () => setScrollY(window.scrollY);
    const onMouse  = e => setCursor({ x:e.clientX, y:e.clientY });
    window.addEventListener("scroll", onScroll);
    window.addEventListener("mousemove", onMouse);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("mousemove", onMouse);
    };
  }, []);

  useReveal();

  const goto = id => document.getElementById(id)?.scrollIntoView({ behavior:"smooth" });

  return (
    <div style={{ background:C.bg, color:C.white, fontFamily:"'Outfit',sans-serif", overflowX:"hidden" }}>
      <GlobalStyles/>
      {/* Custom Cursor */}
      <div style={{ position:"fixed",top:cursor.y,left:cursor.x,zIndex:9999,pointerEvents:"none",width:"8px",height:"8px",background:C.gold,borderRadius:"50%",transform:"translate(-50%,-50%)",mixBlendMode:"difference" }}/>
      <div style={{ position:"fixed",top:cursor.y,left:cursor.x,zIndex:9998,pointerEvents:"none",width:"36px",height:"36px",border:`1px solid ${C.gold}`,borderRadius:"50%",transform:"translate(-50%,-50%)",transition:"all 0.18s ease",opacity:0.5 }}/>
      <Nav scrolled={scrollY > 80} onNav={goto}/>
      <Hero onNav={goto}/>
      <Marquee/>
      <About onNav={goto}/>
      <Stats/>
      <Services/>
      <Portfolio/>
      <QuoteBanner onNav={goto}/>
      <Team/>
      <Testimonials/>
      <Contact/>
      <Footer onNav={goto}/>
    </div>
  );
}